import { useState, type FormEvent, type ReactNode } from 'react';
import { api, errorMessage } from '../api';
import type { LoginResponse } from '../types';

export interface LoginPageProps {
  onLoggedIn: (result: LoginResponse) => void;
}

/** Anmeldeseite: Enter im Formular sendet ab. */
export function LoginPage({ onLoggedIn }: LoginPageProps): ReactNode {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    if (busy) return;
    if (username.trim() === '' || password === '') {
      setError('Bitte Benutzername und Passwort eingeben.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const result = await api.post<LoginResponse>('/api/auth/login', {
        username: username.trim(),
        password,
      });
      onLoggedIn(result);
    } catch (cause: unknown) {
      setError(errorMessage(cause));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={(event) => void submit(event)}>
        <div className="login-brand">
          <span className="brand-mark" aria-hidden="true">
            ⛏
          </span>
          <div>
            <h1>Team-Taskboard</h1>
            <p className="muted">Internes Board für das Server-Team</p>
          </div>
        </div>

        <label className="field">
          <span>Benutzername</span>
          <input
            type="text"
            value={username}
            autoComplete="username"
            autoFocus
            onChange={(event) => setUsername(event.target.value)}
          />
        </label>

        <label className="field">
          <span>Passwort</span>
          <input
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>

        {error !== null && (
          <div className="feedback feedback-error" role="alert">
            <span className="feedback-icon" aria-hidden="true">
              !
            </span>
            <span>{error}</span>
          </div>
        )}

        <button type="submit" className="button button-primary button-block" disabled={busy}>
          {busy ? 'Anmelden …' : 'Anmelden'}
        </button>
      </form>
    </div>
  );
}
